import { render, staticRenderFns } from "./donate-invoice.vue?vue&type=template&id=fbc9f0a2"
import script from "./donate-invoice.vue?vue&type=script&lang=js"
export * from "./donate-invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports